import "../../../css/CreateEvent.css";
import { Event, JSONContent } from "@markit/common.types";
import { detectedSemiCensored } from "@markit/common.utils";
import { useTheme } from "../../../hooks/useTheme";
import PopupModalContainer from "../../Containers/PopupModalContainer";
import { Colors } from "../../../utils/colors";
import ContentViolationTagModal from "../../DeliveryScore/ContentViolationTagModal";
import RectangleButton from "../../Buttons/RectangleButton";
import CustomRichTextEditor from "../../TextFields/CustomRichTextEditor";
import { useEditorState } from "@tiptap/react";
import { useRichTextEditor } from "../../../hooks/useRichTextEditor";
import { validateProductBody } from "../../../utils/productUtils";

interface CreateDescriptionModalProps {
  eventSettings: Event;
  updateEventSettings: (update: Partial<Event>) => void;
  title: string;
  maxLength: number;
  onClose: () => void;
}

const CreateDescriptionModal = (props: CreateDescriptionModalProps) => {
  const { eventSettings, updateEventSettings, title, maxLength, onClose } =
    props;
  const { theme } = useTheme(eventSettings ? eventSettings.theme : undefined);

  const { editor } = useRichTextEditor({
    body: eventSettings.body,
    styles: `height: 300px; overflow: scroll; color: ${theme.PrimaryText.color};`,
    addCharacterCountExtension: {
      include: true,
      limit: maxLength,
    },
    theme,
  });

  const { charactersCount, contentText } = useEditorState({
    editor,
    selector: (context) => ({
      charactersCount: context.editor.storage.characterCount.characters(),
      contentText: context.editor.getText(),
    }),
  });

  const onSave = () => {
    const editorData: JSONContent = editor.getJSON();
    if (!validateProductBody(editor)) {
      return;
    }
    updateEventSettings({ body: editorData });
    onClose();
  };

  return (
    <PopupModalContainer
      headerComp={title}
      valueComp={
        <div className="descriptionTextAreaContainer" style={theme.SecondaryBG}>
          <CustomRichTextEditor
            editor={editor}
            headerComp={<></>}
            isSimplified
            eventTheme={eventSettings.theme}
          />
          <div className="AlignedRowSpaced" style={{ marginTop: 14 }}>
            <span className="bodySubtext">
              {charactersCount}/{maxLength}
            </span>
            {detectedSemiCensored(contentText) ? (
              <ContentViolationTagModal
                message={contentText || ""}
                numCredits={0}
                theme={theme}
                isSemiCensored
              />
            ) : null}
          </div>
        </div>
      }
      fixedBottomContent={
        <div
          className="AlignedRow"
          style={{ gap: 10, paddingInline: 14, paddingTop: 10 }}
        >
          <RectangleButton
            buttonLabel={"Cancel"}
            onPress={onClose}
            altTextColor={theme.PrimaryText.color}
            altColor={theme.NewPrimaryBG.backgroundColor}
            containerStyles={{
              paddingBlock: 14,
              paddingInline: 12,
              border: `0.5px solid ${Colors.GRAY2}`,
            }}
          />
          <RectangleButton
            buttonLabel={"Save"}
            onPress={onSave}
            altTextColor={theme.ButtonText.color}
            altColor={theme.ButtonBG.backgroundColor}
            containerStyles={{ paddingBlock: 14, paddingInline: 12 }}
            disabled={detectedSemiCensored(contentText)}
          />
        </div>
      }
      theme={theme}
      noExit
      closeModal={onClose}
    />
  );
};

export default CreateDescriptionModal;
